import { EN_US } from '@americanexpress/conditional-features/build/constants/locales';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { HOTELS_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';

export const getIsValidCache = (cache, cacheVersion, state) => cache
  && cache?.version === cacheVersion
  && cache?.locale === getActiveLocaleSelector(state);

export const getHotelsCacheKey = (locale = EN_US, taxonomy = '') => `${HOTELS_LOCAL_STORAGE_CACHE_KEY}/${locale}/${taxonomy}`;
